import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rule",
  "use": "icon-rule-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-rule\"><path d=\"M0 1024V0h1024v1024H0zM896 128H128v768h768V128zM384 384H256V256h128v128z m0 192H256V448h128v128z m0 192H256v-128h128v128z m384-384H448V256h320v128z m0 192H448V448h320v128z m0 192H448v-128h320v128z\" p-id=\"42081\" fill=\"#666666\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol